import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import flyer from '../documents/anniversary_flyer.png';

const BULLET = '\u2022';

export class Events extends Component {
  static displayName = Events.name;

  render() {
    return (
        <div className="row">
            <div className="col-lg-7 col-md-8 col-sm-12 content-container">
                <h5 className="pb-2">Simply AA KC 14th Anniversary Celebration</h5>
                <ul className="list-group">
                    <li className="list-group-item list-group-item-dark mt-3"><h6>Saturday, October 17, 2026 - 1pm to 3pm</h6>
                        <ul className="list-group">
                            <li className="list-group-item list-group-item-light">
                                <ul className="list-group">
                                  <li className="list-group-item list-group-item-light mt-3">
                                    <p>Nall Avenue Baptist Church - 6701 Nall Ave, Prairie Village, KS 66208</p>
                                  </li>
                                  <li className="list-group-item list-group-item-light">
                                    <iframe
                                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3100.3571544061383!2d-94.65049288477252!3d39.007165548071605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87c0ec26f98dc199%3A0x78ef6aa0efb63233!2sNall%20Avenue%20Baptist%20Church!5e0!3m2!1sen!2sus!4v1628133845707!5m2!1sen!2sus"
                                      width="100%"
                                      height="255"
                                      frameBorder="0"
                                      style={{ border: 0 }}
                                      allowFullScreen="">
                                    </iframe>
                                  </li>
                                  <li className="list-group-item list-group-item-light">
                                    <p>{BULLET} 12:30pm - Doors Open</p>
                                    <p>{BULLET} 1:00pm - Food Served</p>
                                    <p>{BULLET} 1:15pm - Group History</p>
                                    <p>{BULLET} 1:30pm - Speaker Alek J. (10 yrs) - Kansas City, MO</p>
                                    <p>{BULLET} 2:10pm - BREAK</p>
                                    <p>{BULLET} 2:20pm - Speaker Sara SV. (15 yrs) - Shawnee, KS</p>
                                    <p>{BULLET} 3:00pm - CLOSE</p>
                                    <p>{BULLET} Group history and speaker portion will also be broadcast online here:</p>
                                      <a class="btn btn-sm btn-microsoft-teams" href="https://teams.live.com/meet/9380948233502?p=ZatdsKdbZZFEPHfgq5" target="_blank" rel="noopener" role="button">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-microsoft-teams" viewBox="0 0 16 16">
                                          <path d="M9.186 4.797a2.42 2.42 0 1 0-2.86-2.448h1.178c.929 0 1.682.753 1.682 1.682zm-4.295 7.738h2.613c.929 0 1.682-.753 1.682-1.682V5.58h2.783a.7.7 0 0 1 .682.716v4.294a4.197 4.197 0 0 1-4.093 4.293c-1.618-.04-3-.99-3.667-2.35Zm10.737-9.372a1.674 1.674 0 1 1-3.349 0 1.674 1.674 0 0 1 3.349 0m-2.238 9.488-.12-.002a5.2 5.2 0 0 0 .381-2.07V6.306a1.7 1.7 0 0 0-.15-.725h1.792c.39 0 .707.317.707.707v3.765a2.6 2.6 0 0 1-2.598 2.598z"></path>
                                          <path d="M.682 3.349h6.822c.377 0 .682.305.682.682v6.822a.68.68 0 0 1-.682.682H.682A.68.68 0 0 1 0 10.853V4.03c0-.377.305-.682.682-.682Zm5.206 2.596v-.72h-3.59v.72h1.357V9.66h.87V5.945z"></path>
                                        </svg>
                                        <span class="pl-1">JOIN ONLINE</span>
                                      </a>
                                  </li>
                                  <li className="list-group-item list-group-item-light">
                                    <p>Meats, dressings and drinks will be provided.  Please bring a side dish and/or dessert.</p>
                                  </li>
                                  <li className="list-group-item list-group-item-light">
                                    <p>{BULLET} Family and friends are encouraged to attend.</p>
                                    <p>{BULLET} This is an open (and awesome) meeting!</p>
                                    <p>{BULLET} For more information contact Simply AA KC @
                                      <a className="phone-number" href="tel:913-766-2089"> (913) 766-2089</a> 
                                    </p>
                                  </li>
                                  <li className="list-group-item list-group-item-light">
                                    <a href={flyer} target="_blank" rel="noopener">
                                    <FontAwesomeIcon
                                        style={{
                                            cursor: "pointer",
                                            marginRight: "0.5em",
                                            color: "#ff1b0e",
                                            width: "1.5em",
                                            height: "1.5em"
                                        }}
                                        icon={["fas", "file-pdf"]}
                                    />View Event Flyer
                                    </a>
                                  </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
  }
}
